import { render, staticRenderFns } from "./ImagesAndVideos.vue?vue&type=template&id=42d64127"
import script from "./ImagesAndVideos.vue?vue&type=script&lang=js"
export * from "./ImagesAndVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports